export const SIDEBAR_WORKFLOW = 'future-workflow-editor/workflow';
export const SIDEBAR_NODE_EDGE = 'future-workflow-editor/node-edge';
